// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".request-action-list-wrap[data-v-8e995928]{max-height:600px;overflow-y:auto;overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
